import { Modal } from "../../../../node_modules/bootstrap/dist/js/bootstrap.esm.js";

function initializePhoneModal() {
  const confirmPhoneTextEl = document.getElementById("confirmPhoneText");
  const confirmPhoneText = confirmPhoneTextEl?.innerText ?? "";
  const requestServiceBtn = document.getElementById("js-requestService");
  const messageBoxSuccessText = document.getElementById(
    "js-requestServiceSuccessMessage"
  );
  const messageBoxErrorText = document.getElementById(
    "js-requestServiceErrorMessage"
  );
  const messageBlock = document.getElementById("js-message");
  const componentBlock = document.getElementById("js-component");

  const enterPhoneModalEl = document.getElementById("enterPhoneModal");
  const confirmPhoneModalEl = document.getElementById("confirmPhoneModal");

  if (!enterPhoneModalEl || !confirmPhoneModalEl) {
    return;
  }

  const enterPhoneModal = new Modal(enterPhoneModalEl);
  const confirmPhoneModal = new Modal(confirmPhoneModalEl);
  let phoneNumber =
    confirmPhoneModalEl.getAttribute("data-phone") ||
    confirmPhoneModalEl.getAttribute("data-mobile");

  setConfirmPhoneText();
  initializeconfirmPhoneModalEl();

  function setConfirmPhoneText() {
    if (confirmPhoneTextEl) {
      confirmPhoneTextEl.innerText = confirmPhoneText.replace(
        "{{telefoonnummer}}",
        phoneNumber
      );
    }
  }

  // called when the phone number is successfully changed in the enterPhoneModal
  document.addEventListener("phoneChangeSuccess", function (event) {
    if (confirmPhoneTextEl && event.detail.phoneNumber) {
      phoneNumber = event.detail.phoneNumber;
      setConfirmPhoneText();
    }

    enterPhoneModal.hide();
    confirmPhoneModal.show();
  });

  enterPhoneModalEl.addEventListener("hide.bs.modal", function (event) {
    // reset the phone form when the modal is closed
    resetPhoneForm();
  });

  if (requestServiceBtn) {
    requestServiceBtn.addEventListener("click", function () {
      const serviceId = this.getAttribute("data-serviceId");
      const providerId = this.getAttribute("data-providerId");

      if (serviceId && providerId) {
        openPhoneModal();
      }
    });
  }

  function hasPhoneNumber() {
    return phoneNumber != undefined && phoneNumber.length > 0;
  }

  function openPhoneModal() {
    hasPhoneNumber() ? confirmPhoneModal.show() : enterPhoneModal.show();
  }

  function requestService(serviceId, providerId, comment) {
    const url = "/umbraco/api/KorenFrontend/RequestServiceForm";

    const requestService = {};
    requestService.ServiceId = serviceId;
    if (providerId > -1) {
      requestService.ProviderId = providerId;
    }
    requestService.Comment = comment;

    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestService),
    }).then((response) => {
      confirmPhoneModal.hide();
      messageBlock.classList.remove("d-none");
      componentBlock.classList.add("d-none");
      if (response) {
        messageBoxErrorText.classList.add("d-none");
        messageBoxSuccessText.classList.remove("d-none");
        requestServiceBtn.classList.add("d-none");
      } else {
        messageBoxSuccessText.classList.add("d-none");
        messageBoxErrorText.classList.remove("d-none");
      }
      messageBlock.scrollIntoView({ block: "center" });
    });
  }

  function resetPhoneForm() {
    const telInput = enterPhoneModalEl.querySelector("#ckTel");

    if (telInput) {
      telInput.value = "";
    }
  }

  function initializeconfirmPhoneModalEl() {
    const confirmBtn = confirmPhoneModalEl.querySelector(
      '[data-action="confirm-phone"]'
    );

    if (confirmBtn) {
      confirmBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (requestServiceBtn) {
          const serviceId = requestServiceBtn.getAttribute("data-serviceId");
          const providerId = requestServiceBtn.getAttribute("data-providerId");
          requestService(serviceId, providerId, "");
        }
      });
    }
  }
}

const ticketShopLink = document.querySelector("a[data-ticketshop]");
const loader = document.querySelector("[data-ticketshop] #btnloader");
const ticketShopError = document.getElementById("js-ticketshopErrorMessage");

function initilizeTouchtickets() {
  if (ticketShopLink) {
    ticketShopLink.addEventListener("click", function (event) {
      // do not open the link if it is a touchtickets link, but get the private link instead
      event.preventDefault();
      if (loader) {
        loader.classList.remove("d-none");
      }
      const uri = ticketShopLink.getAttribute("href");      
      GetTouchticketsUrl(uri);
    });
  }
}

function GetTouchticketsUrl(uri) {
  const url = `/umbraco/api/KorenFrontend/GetTouchticketsUrl${uri ? `?uri=${encodeURIComponent(uri)}` : ''}`; 
  const ticketshopWindow = window.open("", "_blank");

  fetch(url, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((response) => {
      if (response && response.success) {
        // Update the window location instead of opening a new one
        if (ticketshopWindow) {
          ticketshopWindow.location.href = response.data;
        } else {
          // Fallback if window was blocked
          window.location.href = response.data;
        }
      } else if (ticketShopError) {
        if (ticketshopWindow) {
          ticketshopWindow.close();
        }
        const errorMessage = response?.korenErrorMessage?.message
          ? response.korenErrorMessage.message
          : errorText;
        ticketShopError.innerText = errorMessage;
        ticketShopError.classList.remove("d-none");
      }
    })
    .catch(() => {
      if (ticketshopWindow) {
        ticketshopWindow.close();
      }
      if (ticketShopError) {
        ticketShopError.innerText = errorText;
        ticketShopError.classList.remove("d-none");
      }
    })
    .finally(() => {
      loader?.classList.add("d-none");
    });
}

function setResendVerificationEmailDisabled(button, disabled) {
  button.disabled = disabled;
  button.classList.toggle("opacity-50", disabled);
}

function bindResendVerificationEmail(link) {
  const loader = link.querySelector(".js-resend-verification-loader");
  const labelSpan = link.querySelector("span:not(.js-resend-verification-loader)");

  if (labelSpan && !link.dataset.resendLinkText) {
    link.dataset.resendLinkText = labelSpan.textContent;
  }

  link.addEventListener("click", function (e) {
    e.preventDefault();
    if (link.disabled) return;

    const resendSentText = link.getAttribute("data-resend-sent-text") || "";
    const defaultErrorText = link.getAttribute("data-resend-error-text") || "";

    setResendVerificationEmailDisabled(link, true);
    link.classList.remove("text-danger");
    if (loader) loader.classList.remove("d-none");

    fetch("/umbraco/api/KorenFrontend/ResendVerificationEmail", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: "{}",
      credentials: "same-origin",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          if (labelSpan) {
            labelSpan.textContent = resendSentText;
          }
        } else {
          const message =
            data.korenErrorMessage?.message || defaultErrorText;
          if (labelSpan) {
            labelSpan.textContent = message;
          }
          link.classList.add("text-danger");
        }
      })
      .catch(() => {
        if (labelSpan) {
          labelSpan.textContent = defaultErrorText;
        }
        link.classList.add("text-danger");
      })
      .finally(() => {
        if (loader) loader.classList.add("d-none");
      });
  });
}

function initializeResendVerificationEmail() {
  document
    .querySelectorAll(".js-resend-verification-email")
    .forEach(bindResendVerificationEmail);
}

const BECOME_MEMBER_POLL_INTERVAL_MS = 5000;
const BECOME_MEMBER_RESEND_DELAY_MS = 20_000;
const BECOME_MEMBER_POLL_MAX_DURATION_MS = 30 * 60 * 1000;

function initializeBecomeMemberEmailPolling() {
  const container = document.getElementById("js-become-member-email-wait");
  if (!container) {
    return;
  }

  const subscriptionRequestId = parseInt(
    container.getAttribute("data-subscription-request-id"),
    10
  );
  const cachedPaymentUrl = container.getAttribute("data-payment-url") || "";
  const paymentButtonText =
    container.getAttribute("data-payment-button-text") || "";
  const timeoutMessage =
    container.getAttribute("data-timeout-message") || "";
  const paymentErrorMessage =
    container.getAttribute("data-payment-error-message") || "";
  const paymentSlot = container.querySelector(".js-become-member-payment-slot");

  if (!subscriptionRequestId || !paymentSlot) {
    return;
  }

  const startTime = Date.now();
  let pollTimerId = null;
  let resendIntervalId = null;
  let isEmailVerified = false;

  function stopPolling() {
    if (pollTimerId !== null) {
      clearInterval(pollTimerId);
      pollTimerId = null;
    }
  }

  function clearResendInterval() {
    if (resendIntervalId !== null) {
      clearInterval(resendIntervalId);
      resendIntervalId = null;
    }
  }

  function showAndEnableResendVerification() {
    if (isEmailVerified) {
      return;
    }

    const resendBlock = container.querySelector(
      ".js-become-member-resend-verification"
    );
    if (!resendBlock) {
      return;
    }

    resendBlock.classList.remove("d-none");

    const resendButton = resendBlock.querySelector(
      ".js-resend-verification-email"
    );
    if (!resendButton) {
      return;
    }

    setResendVerificationEmailDisabled(resendButton, false);
    resendButton.classList.remove("text-danger");

    const labelSpan = resendButton.querySelector(
      "span:not(.js-resend-verification-loader)"
    );
    const linkText = resendButton.dataset.resendLinkText;
    if (labelSpan && linkText) {
      labelSpan.textContent = linkText;
    }
  }

  function showPaymentError(message) {
    paymentSlot.classList.remove("d-none");
    paymentSlot.innerHTML = `<div class="alert alert-warning"><p>${message}</p></div>`;
  }

  function showPaymentUrl(paymentUrl) {
    const waitMessage = container.querySelector(
      ".js-become-member-email-wait-message"
    );
    if (waitMessage) {
      waitMessage.classList.add("d-none");
    }

    const resendBlock = container.querySelector(
      ".js-become-member-resend-verification"
    );
    if (resendBlock) {
      resendBlock.classList.add("d-none");
    }

    const paymentInfo = container.querySelector(".js-become-member-payment-info");

    paymentSlot.classList.remove("d-none");
    paymentSlot.innerHTML = `
      <div class="alert alert-info js-become-member-payment-ready"></div>
      <a href="${paymentUrl}" class="btn btn-primary d-flex align-item-center" target="_blank" rel="noopener noreferrer">${paymentButtonText}</a>`;

    const paymentReadyAlert = paymentSlot.querySelector(
      ".js-become-member-payment-ready"
    );
    if (paymentReadyAlert && paymentInfo) {
      paymentReadyAlert.innerHTML = paymentInfo.innerHTML;
    }

    document.getElementById("js-thankyou-page-intro")?.classList.add("d-none");
  }

  function showPaymentWhenActive() {
    isEmailVerified = true;
    clearResendInterval();
    stopPolling();
    if (cachedPaymentUrl) {
      showPaymentUrl(cachedPaymentUrl);
    } else {
      showPaymentError(paymentErrorMessage);
    }
  }

  function pollHasActiveAccount() {
    if (Date.now() - startTime >= BECOME_MEMBER_POLL_MAX_DURATION_MS) {
      clearResendInterval();
      stopPolling();
      showPaymentError(timeoutMessage);
      return;
    }

    fetch("/umbraco/api/KorenFrontend/HasActiveAccount", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: "{}",
      credentials: "same-origin",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.data === true) {
          showPaymentWhenActive();
        }
      })
      .catch(() => {
        // Polling continues on transient errors
      });
  }

  pollHasActiveAccount();
  pollTimerId = setInterval(pollHasActiveAccount, BECOME_MEMBER_POLL_INTERVAL_MS);
  resendIntervalId = setInterval(
    showAndEnableResendVerification,
    BECOME_MEMBER_RESEND_DELAY_MS
  );
}

document.addEventListener("DOMContentLoaded", function () {
  initializePhoneModal();
  initilizeTouchtickets();
  initializeResendVerificationEmail();
  initializeBecomeMemberEmailPolling();
});
